export const blogsdata = [
  {
    title: "This is the no.2 blog title",
    date: "20/2/2023",
    content: "this is blog2",
    image: "https://picsum.photos/400/200?random=2",
  },
  {
    title: "This is the first blog title",
    date: "20/2/2023",
    content:
      "Hey , this is my first blog post. I want to create my own portfolio website that also contain blogs inside it",
    image: "https://picsum.photos/400/200?random=1",
  }
];

export const first = [
  {
    title: "This is the first blog title",
    date: "20/2/2023",
    content:
      "Hey , this is my first blog post. I want to create my own portfolio website that also contain blogs inside it",
    image:
      "https://i.pinimg.com/564x/ca/ea/13/caea131a399fc37c4429895fae91bb76.jpg",
  },
];
